import { ConsignmentEmailPreviewPage } from "@/features/consignment-settlement/pages/ConsignmentEmailPreviewPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/admin/consignment-settlement/$id/email-preview",
)({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({ permissions: ["vendor_consignment.view"] })
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: ConsignmentEmailPreviewPage,
});
